import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LOCAL_STORAGE_PREFIX } from 'src/app/shared/constants/LocalStoragePrefix';

export interface UserSession {
  nanoid: string;
  nome: string;
  foto: string;
  permissoes: string[],
  permissoesGrupo?: string[]
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private SESSION_NAME: string = `${LOCAL_STORAGE_PREFIX}_SESSION`;

  private usuario: UserSession | undefined;

  constructor(
    private router: Router,
  ) { }

  saveUser(data: UserSession | undefined) {
    window.localStorage.setItem(`${this.SESSION_NAME}_USER`, JSON.stringify(data));
  }

  getUser(): UserSession | undefined {
    this.usuario = JSON.parse(window.localStorage.getItem(`${this.SESSION_NAME}_USER`) || '{}');
    return this.usuario;
  }

  removeUser() {
    this.usuario = undefined;
  }

  saveSession(token: string) {
    localStorage.setItem(this.SESSION_NAME, token);
  }

  getSession(): string | null {
    return localStorage.getItem(this.SESSION_NAME);
  }

  removeSession() {
    const returnUrl = this.router.url;
    localStorage.removeItem(this.SESSION_NAME);
    this.removeUser();
    this.router.navigate(['login', {
      queryParams: {
        returnUrl: returnUrl === '/' ? undefined : returnUrl
      }
    }]);
  }
}
